import { Fragment, useEffect } from 'react';

import Button from 'components/buttons/button';
const HandleTooManyRequests = ({ handleClose }) => {
  const cancelClicked = () => {
    handleClose();
  };

  return (
    <Fragment>
      <div className="error-message">
        <h5 className="title">Registration Error</h5>
        <hr />
        <p>You've reached the maximum number of allowed registrations for a single day (3). Please try again after 24 hours.</p>
        <hr />
      </div>
      <div className="error-button-group">
        <Button
          className="button button-cancel"
          type="button"
          text="Cancel"
          onClick={ cancelClicked }
        />
      </div>
    </Fragment>
  );
};

export default HandleTooManyRequests;
